import { useTranslation } from "react-i18next";
import { hasAccountantOptions } from "utils/stepsOptions";
import CompanyForm from "../CompanyForm";
import PersonalForm from "../PersonalForm";
import SuccessForm from "../SuccessForm";
import ToggleFormItem from "../ToggleFormItem";

export default function useSteps() {
  const { t } = useTranslation();

  const steps = [
    {
      title: `${t("Personal info")}`,
      content: <PersonalForm />,
      fields: ["firstName", "lastName", "email", "phone"],
    },
    {
      title: `${t("Company")}`,
      content: <CompanyForm />,
      fields: ["company", "companyStatus"],
    },
    // {
    //   title: `${t("What is your company's legal status?")} *`,
    //   content: <ToggleFormItem name="legalStatus" options={legalStatusOptions} />,
    //   fields: ["legalStatus"],
    // },
    {
      title: `${t("Do you already have an accountant?")} *`,
      content: <ToggleFormItem name="hasAccountant" options={hasAccountantOptions} />,
      fields: ["hasAccountant"],
    },
    // {
    //   title: `${t("You would like an accountant for ... ?")} *`,
    //   content: <ToggleFormItem name="accountantService" options={accountantProposesOptions} />,
    //   fields: ["accountantService"],
    // },
    // {
    //   title: `${t("Which type of accountant do you prefer?")} *`,
    //   content: <ToggleFormItem name="accountantType" options={accountantTypesOptions} />,
    //   fields: ["accountantType"],
    // },
    // {
    //   title: `${t("What is your business sector?")} *`,
    //   content: <ToggleFormItem name="sector" options={serviceTypeOptions} />,
    //   fields: ["sector"],
    // },
    // {
    //   title: `${t("What is your annual revenue?")} *`,
    //   content: <ToggleFormItem name="annualRevenue" options={revenueOptions} />,
    //   fields: ["annualRevenue"],
    // },
    // {
    //   title: `${t("How many employees do you have?")} *`,
    //   content: <ToggleFormItem name="employeeCount" options={numberOfEmployeesOptions} />,
    //   fields: ["employeeCount"],
    // },

    {
      content: <SuccessForm />,
    },
  ];

  return steps;
}
